export default {
  'apiPath': '/backend'
};
